export function afterNextRender(action: () => void) {
  // Delay action a few frames until after DOM changes are rendered
  requestAnimationFrame(() => requestAnimationFrame(() => action()));
}
